module.exports = __webpack_public_path__ + "img/379069223f344e39fad8679284084048.gif";